import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import FundCompactList from "../components/FundCompactList";

const FundSplitView = () => <MasterDetailLayout list={<FundCompactList />} />;

export default FundSplitView;
